import { render, staticRenderFns } from "./ManageAdmin.vue?vue&type=template&id=509f9574&"
import script from "./ManageAdmin.vue?vue&type=script&lang=js&"
export * from "./ManageAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports